import companies from 'api/companies'
import auth from 'api/auth'
import cookies from 'utilities/cookies'
import * as types from '../mutation-types'
import * as namedTypes from '../namespaced-mutation-types'

const Promise = window.Promise || require('promise')

export const addCompany = ({ commit, dispatch, rootState }, payload) => {
  return companies.add(rootState.manipulators.token, payload)
    .then((data) => {
      dispatch('manipulators/fetchManipulatorFirstCompany', null, { root: true })
      dispatch('users/fetchUserData', null, { root: true })
      return Promise.resolve(data.results)
    }, (err) => {
      return Promise.reject(err)
    })
}

export const updateCompany = ({ commit, dispatch, rootState }, payload) => {
  return companies.updateById(rootState.manipulators.token, payload.id, payload)
    .then((data) => {
      dispatch('manipulators/fetchManipulatorFirstCompany', null, { root: true })
      dispatch('users/fetchUserData', null, { root: true })
      return Promise.resolve(data.results)
    }, (err) => {
      return Promise.reject(err)
    })
}

export const fetchCompanyEntryByAlias = ({ commit, rootState }, alias = '') => {
  return companies.getByAlias(rootState.users.token, alias).then((data) => {
    commit(types.COMPANY_ENTRY, data.results)
    return Promise.resolve(data.results)
  }, (err) => {
    return Promise.reject(err)
  })
}

export const fetchCompanyVacancies = ({ commit, rootState }, params = { page: 1 }) => {
  if (typeof rootState.utilities.vacanciesLoadingTimeout !== 'undefined') {
    clearTimeout(rootState.utilities.vacanciesLoadingTimeout)
    commit(namedTypes.VACANCIES_LOADING, false, { root: true })
    commit(namedTypes.VACANCIES_LOADING_TIMEOUT, undefined, { root: true })
  }
  commit(namedTypes.VACANCIES_LOADING, true, { root: true })
  commit(namedTypes.VACANCIES_LOADING_TIMEOUT, setTimeout(function () {
    return companies.getCompanyVacancies(params).then((data) => {
      commit(types.COMPANY_VACANCIES, {
        loadMore: params.loadMore || false,
        ...data.results
      })
      commit(namedTypes.VACANCIES_LOADING, false, { root: true })
      commit(namedTypes.VACANCIES_LOADING_TIMEOUT, undefined, { root: true })
      return Promise.resolve(data.results)
    }, (err) => {
      commit(types.COMPANY_VACANCIES, {})
      commit(namedTypes.VACANCIES_LOADING, false, { root: true })
      commit(namedTypes.VACANCIES_LOADING_TIMEOUT, undefined, { root: true })
      return Promise.reject(err)
    })
  }, 300), { root: true })
}

export const fetchSimilarCompanies = ({ commit, rootState }, params = { page: 1 }) => {
  return companies.get(rootState.manipulators.token, params).then((data) => {
    commit(types.SIMILAR_COMPANIES, data.results)
    return Promise.resolve(data.results)
  }, (err) => {
    commit(types.SIMILAR_COMPANIES, {})
    return Promise.reject(err)
  })
}

export const fetchCompanies = ({ commit, rootState, state }, params = { page: 1 }) => {
  if (typeof rootState.utilities.companiesLoadingTimeout !== 'undefined') {
    clearTimeout(rootState.utilities.companiesLoadingTimeout)
    commit(namedTypes.COMPANIES_LOADING, false, { root: true })
    commit(namedTypes.COMPANIES_LOADING_TIMEOUT, undefined, { root: true })
  }
  commit(namedTypes.COMPANIES_LOADING, true, { root: true })
  commit(namedTypes.COMPANIES_LOADING_TIMEOUT, setTimeout(function () {
    if (typeof state.companies.isQueryAnd !== 'undefined') {
      params = {
        is_query_and: (state.companies.isQueryAnd ? 'yes' : 'no'),
        ...params
      }
    } else {
      params = {
        is_query_and: 'yes',
        ...params
      }
    }
    return companies.get(rootState.manipulators.token, params).then((data) => {
      commit(types.COMPANIES, data.results)
      commit(namedTypes.COMPANIES_LOADING, false, { root: true })
      commit(namedTypes.COMPANIES_LOADING_TIMEOUT, undefined, { root: true })
      return Promise.resolve(data.results)
    }, (err) => {
      commit(types.COMPANIES, {})
      commit(namedTypes.COMPANIES_LOADING, false, { root: true })
      commit(namedTypes.COMPANIES_LOADING_TIMEOUT, undefined, { root: true })
      return Promise.reject(err)
    })
  }, 300), { root: true })
}

export const companyRegister = ({ commit }, signupData) => {
  return auth.companyRegister(signupData).then((data) => {
    commit(namedTypes.MANIPULATOR_DATA, data.user, { root: true })
    commit(namedTypes.MANIPULATOR_TOKEN, data.token, { root: true })
    cookies.set('debutManipulatorToken', data.token, { expires: 86400 })
    return Promise.resolve(data)
  }, (err) => {
    commit(namedTypes.MANIPULATOR_DATA, {}, { root: true })
    commit(namedTypes.MANIPULATOR_TOKEN, '', { root: true })
    return Promise.reject(err)
  })
}

export const companyLogin = ({ commit }, loginData) => {
  return auth.companyLogin(loginData).then((data) => {
    commit(namedTypes.MANIPULATOR_DATA, data.user, { root: true })
    commit(namedTypes.MANIPULATOR_TOKEN, data.token, { root: true })
    commit(namedTypes.TOGGLE_LOGIN_ALERT, {
      isShow: true,
      isSucceeded: true
    }, {
      root: true
    })
    cookies.set('debutManipulatorToken', data.token, { expires: 86400 })
    try {
      window.sessionStorage.setItem('debutManipulatorToken', data.token)
      window.sessionStorage.setItem('debutManipulatorData', JSON.stringify(data.user))
    } catch (e) {}
    return Promise.resolve(data)
  }, (err) => {
    commit(namedTypes.MANIPULATOR_DATA, {}, { root: true })
    commit(namedTypes.MANIPULATOR_TOKEN, '', { root: true })
    cookies.remove('debutManipulatorToken')
    try {
      window.sessionStorage.removeItem('debutManipulatorToken')
      window.sessionStorage.removeItem('debutManipulatorData')
    } catch (e) {}
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./src/vuex/companies/actions.js